import React from 'react';
import { Grid, Paper, Typography, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ROOM_TYPES } from '../../../types/chatMessageDeletionHistory';
import {
  SearchControlsLayout,
  MultiStatusSelect,
  SearchTextField,
  SearchResultCounter,
  SearchActionButtons
} from '../../common';

interface SearchFormProps {
  // 検索条件
  messageSearchTerm: string;
  selectedRoomTypes: string[];
  messageStatus: string; // 'all', 'deleted', 'restored'
  totalCount: number;
  // イベントハンドラー
  onMessageSearchChange: (value: string) => void;
  onRoomTypeChange: (types: string[]) => void;
  onMessageStatusChange: (value: string) => void;
  onSearch: () => void;
  onClearFilters: () => void;
  onClearMessageSearch: () => void;
}

const SearchForm: React.FC<SearchFormProps> = ({
  messageSearchTerm,
  selectedRoomTypes,
  messageStatus,
  totalCount,
  onMessageSearchChange,
  onRoomTypeChange,
  onMessageStatusChange,
  onSearch,
  onClearFilters,
  onClearMessageSearch
}) => {
  // ルームタイプの選択ハンドラ
  const handleRoomTypeChange = (event: any) => {
    onRoomTypeChange(event.target.value);
  };

  // メッセージ状態の選択ハンドラ
  const handleMessageStatusChange = (event: SelectChangeEvent) => {
    onMessageStatusChange(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSearch();
  };

  return (
    <Paper
      component="form"
      elevation={2}
      sx={{ p: 3, mb: 3 }}
      onSubmit={handleSubmit}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>検索条件</Typography>

      {/* 検索フィールド一覧 */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="message-status-select-label">メッセージ操作</InputLabel>
            <Select
              labelId="message-status-select-label"
              id="message-status-select"
              value={messageStatus}
              onChange={handleMessageStatusChange}
              label="メッセージ操作"
            >
              <MenuItem value="all">すべて</MenuItem>
              <MenuItem value="deleted">削除</MenuItem>
              <MenuItem value="restored">復元</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={4}>
          <MultiStatusSelect
            id="room-type-select"
            label="ルーム"
            value={selectedRoomTypes}
            onChange={handleRoomTypeChange}
            options={ROOM_TYPES}
            size="small"
            emptyLabel="すべてのルーム"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <SearchTextField
            label="メッセージ検索"
            value={messageSearchTerm}
            onChange={(e) => onMessageSearchChange(e.target.value)}
            onClear={onClearMessageSearch}
          />
        </Grid>
      </Grid>

      {/* 検索結果件数とボタン */}
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          {/* 左側空白 */}
        </Grid>
        <Grid item xs={2} sx={{ textAlign: 'center' }}>
          <SearchResultCounter count={totalCount} />
        </Grid>
        <Grid item xs={5}>
          <SearchActionButtons
            onClear={onClearFilters}
            onSearch={onSearch}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SearchForm;